import {
  GET_SERIES,
  GET_ADMIN_SERIES,
  CREATE_SERIES,
  UPDATE_SERIES,
  DELETE_SERIES,
} from "../actions/types";

const initialState = {
  public: [],
  admin: [],
};

export default function seriesReducer(state = initialState, action) {
  switch (action.type) {
    case GET_SERIES:
      return { ...state, public: action.payload || [] };
    case GET_ADMIN_SERIES:
      return { ...state, admin: action.payload || [] };
    case CREATE_SERIES:
      return { ...state, admin: [...state.admin, action.payload] };
    case UPDATE_SERIES: {
      const updated = action.payload;
      return {
        ...state,
        admin: state.admin.map((s) => (s._id === updated._id ? updated : s)),
      };
    }
    case DELETE_SERIES: {
      const removed = action.payload;
      return {
        ...state,
        admin: state.admin.filter((s) => s._id !== removed._id),
      };
    }
    default:
      return state;
  }
}
